import funParabola, { initAni } from './parabola.js'

export default {
  data() {
    return {
      funParabola,
      initAni
    }
  },
  mounted() {
    initAni()
  },
  methods: {
    addCartAni(ballDom) {
      const cart = document.getElementById('shoppingCart')
      const ball = this.$refs[ballDom]
      ball.style.visibility = 'visible'
      cart.addEventListener('animationend', () => {
        cart.classList.remove('animated', 'swing')
      })
      const myParabola = funParabola(ball, cart, {
        curvature: 0.003,
        speed: 688,
        complete: () => {
          ball.style.visibility = 'hidden'
          cart.classList.add('animated', 'swing')
        }
      })
      myParabola.init()
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/ballAnimation.js